import { useContext } from "react";
import LangContext from "../../../contexts/LangContext";
import { translate } from "../../../helper";

import "./index.css";

const Tab = (props) => {
  const { lang } = useContext(LangContext);

  return (
    <nav className="sh-nav-tab-section">
      <div className="nav nav-tabs d-flex justify-content-center" id="nav-tab" role="tablist">
        <button onClick={props.handleTabChange} datavalue="federal" className={props.tab === "federal" ? "nav-link active" : "nav-link"} data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">
          <li>
            <a href="/" className="tab">
              {translate("federal", lang)}
            </a>
          </li>
        </button>
        <button onClick={props.handleTabChange} datavalue="provincial" className={props.tab === "provincial" ? "nav-link active" : "nav-link"} data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">
          <li>
            <a href="/" className="tab">
              {translate("provincial", lang)}
            </a>
          </li>
        </button>
      </div>
    </nav>
  );
};

export default Tab;
